import { GlobalHeader } from '@quickenloans-ui-suite/global-head';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import * as buildEnvs from '../../../../_envs.json';
import Breadcrumb from '../../Atoms/Breadcrumb';
import Footer from '../Footer';
import ComplianceController from './ComplianceController';
import { classNames, testAttributes } from './Constants';
import { mainContentWithGlobal, rootPath } from './Layout.module.scss';

const Layout = ({ 
    headerProps,
    footerProps, 
    isPreview = false, 
    children, 
    breadcrumbProps = [],
    hasHero = false,
    includeBanner = true
}) => 
{
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    const [qlOffsetHeight, setQlOffsetHeight] = useState( 0 );
    const [breadcrumbsHeight, setBreadcrumbsHeight] = useState(0);

    const { globalNav, globalAccount } = headerProps;
    const renderedFooterProps = {
        ...footerProps
    }

    const offsetStyle = {
        '--ql-top-offset': `${qlOffsetHeight}px`,
        '--ql-offset-breadcrumbs': `${breadcrumbsHeight}px`
    };


    const onBannerHeightChange = (bannerHeight) => 
    {
        if ( bannerHeight !== qlOffsetHeight )
        {
            setQlOffsetHeight( bannerHeight )
        }
    }

    const onBreadcumbHeightChange = (height) => 
    {
        if ( height !== breadcrumbsHeight )
        {
            setBreadcrumbsHeight( height );
        }
    }

    if(!Array.isArray(renderedFooterProps?.disclosure))
    {
        renderedFooterProps.disclosure = [];
    }

    useEffect(() => 
    {
        if (typeof window !== 'undefined')
        {
            Promise.resolve().then(() =>
            {
                window.scrollTo(0, 0);
            });
        }
    }, []);

    return (
        <>
            <ComplianceController
                includeBanner={includeBanner}
                bannerMessage={headerProps?.banner?.message}
                onBannerHeightChange={onBannerHeightChange}
            />
            <app-root 
                class={`${rootPath} layout_root ${isPreview ? 'isPreview' : ''}`} 
                data-testid={testAttributes.PAGE_ROOT}
                style={offsetStyle}
            >
                <GlobalHeader 
                    hostPlatform="gatsby" 
                    LinkComponent={Link} 
                    environment={buildEnvs[activeEnv].GN_BBF_ENV} 
                    defaultMainMenu={{ globalNav, globalAccount }}
                />
                <main role="main" className={mainContentWithGlobal} data-testid={testAttributes.MAIN_CONTAINER}>
                    {
                        breadcrumbProps.length > 0 && 
                        <div data-testid={testAttributes.MAIN_BREADCRUMB_CONTAINER} className={classNames.MAIN_BREADCRUMB_CONTAINER}>
                            <Breadcrumb 
                                breadcrumbs={breadcrumbProps} 
                                hasHero={hasHero} 
                                onHeightChange={onBreadcumbHeightChange}
                            />
                        </div>
                    }
                    {children}
                </main>
                <Footer {...renderedFooterProps} />
            </app-root>
        </>
    )
}

Layout.propTypes = {
    /** header = menu items, logo, CTA */
    headerProps: PropTypes.object.isRequired,
    /** footer = legalese, bottom menu */
    footerProps: PropTypes.object.isRequired,
    /** add className that displays Preview watermark over page */
    isPreview: PropTypes.bool,
    /** children: content of page */
    children: PropTypes.node.isRequired,
    /** header = menu items, logo, CTA */
    breadcrumbProps: PropTypes.array, 
    /** includeBanner = show banner above all content (default true) */
    includeBanner: PropTypes.bool,
    /** hasHero = change the breadcrumb margin to match with hero design */
    hasHero: PropTypes.bool
}

export default Layout;
